import type { WorkerAPI } from "@pdfking/compatibility"

const internalCreateWorker = <T, R>(worker: Worker): WorkerAPI<T, R> => ({
  on: (handler: (data: any) => void) =>
    (worker.onmessage = (event: MessageEvent) => handler(event.data)),
  send: (message: any) => worker.postMessage(message),
})

export const CreateWorker = <T, R>(path: string | URL): WorkerAPI<T, R> => {
  console.info("creating worker", path)
  const worker = new Worker(path, { type: "module" })
  worker.onerror = console.error
  return internalCreateWorker(worker)
}

export const CreateWorkerFromSelf = <T, R>(): WorkerAPI<T, R> =>
  internalCreateWorker(self as unknown as Worker)
